import React from 'react';
import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { compatWrapper } from '@backstage/core-compat-api';

const teamInfoCard = EntityCardBlueprint.make({
  name: 'team-info',
  params: {
    filter: 'kind:component',
    type: 'info',
    loader: async () => {
      const { TeamInfoCard } = await import('./TeamInfoCard');
      return compatWrapper(React.createElement(TeamInfoCard));
    },
  },
});

export const teamInfoPlugin = createFrontendPlugin({
  pluginId: 'team-info',
  extensions: [teamInfoCard],
});
